<template>
  <div
    class="bg-white position-relative page-initial"
    :style="{
      transform: `translateY(${$parent.scrollTop*-1}px)`,
      height: `calc(100vh - ${initialHeight} + ${$parent.scrollTop}px)`
    }"
  >
    <!--    Calendar picker-->
    <calendar-picker ref="calendarPicker" />
    <div v-if="loadingAppointment" class="text-center text-primary3 pt-5">
      <b-spinner label="Spinner" size="lg" />
    </div>
    <template v-else>
      <template v-if="appointmentList.length === 0">
        <div class="appointment-not-available bg-white d-flex justify-content-center pt-4">
          <div class="w-100 px-4">
            <svg width="84" height="84" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M31.8749 36.0001H4.12509C1.84955 36.0001 0 34.1505 0 31.875V7.12497C0 4.84943 1.84955 3.00015 4.12509 3.00015H31.8749C34.1505 3.00015 36 4.84943 36 7.12497V31.875C36 34.1505 34.1505 36.0001 31.8749 36.0001ZM4.12509 5.25015C3.09155 5.25015 2.25 6.09143 2.25 7.12497V31.875C2.25 32.9085 3.09155 33.7501 4.12509 33.7501H31.8749C32.9084 33.7501 33.75 32.9085 33.75 31.875V7.12497C33.75 6.09143 32.9084 5.25015 31.8749 5.25015H4.12509Z" fill="#024668" />
              <path d="M34.875 14.2502H1.125C0.503998 14.2502 0 13.7462 0 13.1252C0 12.5042 0.503998 12.0002 1.125 12.0002H34.875C35.496 12.0002 36 12.5042 36 13.1252C36 13.7462 35.496 14.2502 34.875 14.2502Z" fill="#024668" />
              <path d="M8.62498 9C8.00398 9 7.49998 8.496 7.49998 7.875V1.125C7.49998 0.503998 8.00398 0 8.62498 0C9.24599 0 9.74998 0.503998 9.74998 1.125V7.875C9.74998 8.496 9.24599 9 8.62498 9Z" fill="#024668" />
              <path d="M27.375 9C26.754 9 26.25 8.496 26.25 7.875V1.125C26.25 0.503998 26.754 0 27.375 0C27.996 0 28.5 0.503998 28.5 1.125V7.875C28.5 8.496 27.996 9 27.375 9Z" fill="#024668" />
              <path d="M22.138 27.8327C21.6988 28.2718 20.8673 28.1531 20.2818 27.5676L13.9178 21.2036C13.3324 20.6181 13.2136 19.7866 13.6527 19.3474C14.0918 18.9083 14.9233 19.0271 15.5088 19.6126L21.8728 25.9766C22.4583 26.5621 22.5771 27.3936 22.138 27.8327Z" fill="#024668" />
              <path d="M13.8621 27.8327C14.3012 28.2718 15.1328 28.1531 15.7182 27.5676L22.0822 21.2036C22.6677 20.6181 22.7865 19.7866 22.3474 19.3474C21.9083 18.9083 21.0767 19.0271 20.4912 19.6126L14.1273 25.9766C13.5418 26.5621 13.423 27.3936 13.8621 27.8327Z" fill="#024668" />
            </svg>
            <h3 class="pt-2 mb-5 font-rubik-medium">
              JAM PRAKTIK <br>TIDAK TERSEDIA
            </h3>
            <b-button size="lg" block variant="primary-3" class="border-r25px" @click="$parent.downloadApp()">
              DOWNLOAD YESDOK
            </b-button>
            <b-button size="lg" block variant="outline-primary-3" class="border-r25px" @click="askSchedule()">
              MINTA JADWAL
            </b-button>
          </div>
        </div>
      </template>
      <template v-else>
        <div v-if="$parent.widthScreen > 467" class="button-continue d-flex px-sm-5 px-3">
          <b-button v-if="$parent.txtTimePicker" v-b-modal.modal-share-social pill variant="primary-3" class="mr-3 px-3">
            <font-awesome-icon
              icon="share-alt"
              size="lg"
            />
          </b-button>
          <b-button
            :disabled="!$parent.txtTimePicker"
            size="lg"
            block
            class="border-r25px font-rubik-medium btn-blue-yd"
            @click="handleScheduleNext()"
          >
            Lanjutkan <font-awesome-icon icon="chevron-right" class="mr-n2" /> <font-awesome-icon icon="chevron-right" />
          </b-button>
          <!-- <b-button
            v-else
            v-scroll-to="{
              el: `#yd${$moment.unix(nearestToday).startOf('days').unix()}`,
              container: '#nav-scroller',
              offset: 0,
              duration: 700,
              onDone: goToNearest,
              cancelable: false,
            }"
            block
            size="lg"
            variant="success-2"
            class="border-r25px font-rubik-medium"
          >
            Lihat Jadwal Tersedia
          </b-button> -->
        </div>
      </template>
    </template>
    <b-modal
      id="modal-no-appointment"
      ref="modalNoAppointment"
      centered
      hide-header
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
    >
      <div class="text-center pt-3">
        <h4 class="mb-5">
          JAM PRAKTIK SUDAH TIDAK TERSEDIA
        </h4>
        <p class="mt-5">
          Silahkan memilih jam praktik<br>yang tersedia
        </p>
        <b-button
          block
          variant="primary-3"
          class="btn-next mt-5 border-r25px"
          @click="closeNoAvailableBooking()"
        >
          TUTUP
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import CalendarPicker from '@/components/appointment-component/CalendarPicker'
export default {
  name: 'Initial',
  components: {
    CalendarPicker
  },
  data: () => ({
    calendar: {
      date: [],
      hour: null,
      selectedDate: null
    },
    appointmentList: [],
    loadingAppointment: true,
    nearestToday: null
  }),
  computed: {
    doctorData () {
      return this.$store.state.doctor.doctorData
    },
    initialHeight () {
      return this.profileDoctorHeight > 154 ? '271px' : this.profileDoctorHeight > 130 ? '247px' : '235px'
    },
    profileDoctorHeight () {
      return this.$parent.profileDoctorHeight
    }
  },
  mounted () {
    this.$parent.txtDatePicker = this.$moment().format('YYYY, MM, DD')
    this.$parent.timestampNow = this.$moment().unix()
    this.$parent.timestampStart = this.$moment().unix()
    this.$parent.timestampEnd = this.$moment.unix(this.$parent.timestampStart).endOf('day').unix()
    this.checkingBookAvailable()
  },
  methods: {
    handleScheduleNext () {
      this.$store.commit('doctor/SET_COUNTDOWN_OFF', false)
      this.$store.commit('doctor/SET_BOOKING_APPOINTMENT', this.$store.state.doctor.doctorData.Appointments.find(o => o.PublicID === this.$parent.txtTimePicker))
      localStorage.setItem('public_id', this.$store.state.doctor.booking.selectedAppointment.PublicID)
      this.$store.commit('doctor/SET_STEP', 'confirmation')
      localStorage.setItem('step', 'confirmation')
    },
    checkingBookAvailable () {
      if (this.$store.state.doctor.booking.bookingFailed) {
        return this.$refs.modalNoAppointment.show()
      }
    },
    closeNoAvailableBooking () {
      this.$store.commit('doctor/SET_BOOKING_FAILED', true)
      return this.$refs.modalNoAppointment.hide()
    },
    goToNearest () {
      this.$nextTick(() => {
        const componentCalendar = this.$refs.calendarPicker
        if (componentCalendar) {
          componentCalendar.onDoneScrollNearest()
        }
      })
    },
    askSchedule () {
      let token = ''
      if (localStorage.getItem('token')) {
        token = localStorage.getItem('token')
      }
      const payload = {
        Token: token,
        DoctorPublicID: this.doctorData.Doctor.PublicID
      }
      this.$store
        .dispatch('patient/askSchedule', payload)
        .then((response) => {
          this.openMailClient(response.Data)
        })
        .catch(() => {
          const data = {
            Emails: [null],
            Subject: null,
            Message: null
          }
          this.openMailClient(data)
        })
    },
    openMailClient (data) {
      const doctorEmail = data.Emails[0] ? data.Emails[0] : this.doctorData.Doctor.Email
      const subjectEmail = data.Subject ? encodeURIComponent(data.Subject) : 'Pasien minta jadwal'
      const messageEmail = data.Message ? data.Message : ''
      if (messageEmail) {
        window.open(`mailto:?To=${doctorEmail}&Subject=${subjectEmail}&Body=${messageEmail}`, '_blank')
      } else {
        const path = process.env.BASE_SPECIALIST_URL
        const letter = this.doctorData.Doctor.Fullname ? this.doctorData.Doctor.Fullname.split('') : ''
        const lastIndex = letter.length - 1
        if (letter[lastIndex] === ' ') {
          letter.splice(lastIndex, 1)
        } else if (letter[0] === ' ') {
          letter.splice(0, 1)
        }
        const joinedLetter = letter.join('')
        window.open(`mailto:?To=${doctorEmail}&Subject=${subjectEmail}&Body=Hai ${joinedLetter},%0A%0DPasien mengajak Anda untuk untuk membuat Jadwal Dokter.%0A%0DLakukan penjadwalan dengan klik tombol dibawah ini:%0A%0DBUAT JADWAL:%0A${path}console/calendar%0A%0DTerima Kasih`, '_blank')
      }
    }
  }
}
</script>

<style lang="scss">
  $primary: #024668;
  .bottom-4 {
    bottom: 1.5rem;
  }
  .calendar-picker {
    color: $primary;
    .text-lg {
      font-size: 1.125rem;
      margin-bottom: 0;
    }
  }

  .appointment-not-available {
    text-align: center;
    position: relative;
    z-index: 1;
    color: $primary;
  }

  .page-initial {
    @media screen and (max-height: 568px) {
      min-height: 500px;
    }
  }

</style>
